import clsx from "clsx";
import { ArrowUp } from "lucide-react";
import type { ReactNode } from "react";

interface SendButtonProps {
  variant: "cyan" | "magenta";
  disabled?: boolean;
  pending?: boolean;
  onPointerDown?: React.PointerEventHandler<HTMLButtonElement>;
  className?: string;
  icon?: ReactNode;
}

export function SendButton({
  variant,
  disabled,
  pending,
  onPointerDown,
  className,
  icon,
}: SendButtonProps): React.JSX.Element {
  const activeBg = variant === "cyan" ? "bg-cyber-cyan" : "bg-cyber-magenta";
  const disabledBg = "bg-cyber-muted/80";

  return (
    <button
      type="submit"
      disabled={disabled}
      onPointerDown={onPointerDown}
      className={clsx(
        "inline-flex h-8 w-8 items-center justify-center rounded-full transition-colors",
        disabled
          ? clsx(disabledBg, "text-cyber-surface cursor-not-allowed")
          : clsx(activeBg, "text-white hover:opacity-90"),
        pending && "opacity-90",
        className,
      )}
      aria-label="Send"
      title="Send"
    >
      {pending ? (
        <span className="animate-spin-glow inline-block">◐</span>
      ) : (
        (icon ?? <ArrowUp size={16} />)
      )}
    </button>
  );
}
